/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SubscribeConfigObject } from './SubscribeConfigObject';
import {
    SubscribeConfigObjectFromJSON,
    SubscribeConfigObjectFromJSONTyped,
    SubscribeConfigObjectToJSON,
} from './SubscribeConfigObject';
import type { SubscribeInstallationProviderOptions } from './SubscribeInstallationProviderOptions';
import {
    SubscribeInstallationProviderOptionsFromJSON,
    SubscribeInstallationProviderOptionsFromJSONTyped,
    SubscribeInstallationProviderOptionsToJSON,
} from './SubscribeInstallationProviderOptions';

/**
 * 
 * @export
 * @interface SubscribeConfig
 */
export interface SubscribeConfig {
    /**
     * Per-object subscribe configuration. Optional: when omitted, the subscribe objects come from the integration revision, and the config may carry only `providerOptions`.
     * @type {{ [key: string]: SubscribeConfigObject; }}
     * @memberof SubscribeConfig
     */
    objects?: { [key: string]: SubscribeConfigObject; };
    /**
     * 
     * @type {SubscribeInstallationProviderOptions}
     * @memberof SubscribeConfig
     */
    providerOptions?: SubscribeInstallationProviderOptions;
}

/**
 * Check if a given object implements the SubscribeConfig interface.
 */
export function instanceOfSubscribeConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscribeConfigFromJSON(json: any): SubscribeConfig {
    return SubscribeConfigFromJSONTyped(json, false);
}

export function SubscribeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : (mapValues(json['objects'], SubscribeConfigObjectFromJSON)),
        'providerOptions': !exists(json, 'providerOptions') ? undefined : SubscribeInstallationProviderOptionsFromJSON(json['providerOptions']),
    };
}

export function SubscribeConfigToJSON(value?: SubscribeConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : (mapValues(value.objects, SubscribeConfigObjectToJSON)),
        'providerOptions': SubscribeInstallationProviderOptionsToJSON(value.providerOptions),
    };
}

